/**
 * Lien pré-rempli `/new` (spec §3.4) : `ValidatedPoll` → `initialData` du
 * `PollCreator` (forme `DatePollSuggestion` : `timeSlots` avec `dates`
 * optionnelles, convertis ensuite par `convertGeminiSlotsToTimeSlotsByDate`).
 *
 * Fonction pure : rien n'est créé ni enregistré. Le visiteur relit le
 * sondage dans l'éditeur puis publie lui-même.
 */
import type { ValidatedPoll } from "./validate.js";

export interface NewPollInitialData {
  type: "date";
  title: string;
  description?: string;
  dates: string[];
  timeSlots?: Array<{ start: string; end: string; dates: string[] }>;
}

export function toNewPollInitialData(value: ValidatedPoll): NewPollInitialData {
  const timeSlots: Array<{ start: string; end: string; dates: string[] }> = [];
  for (const date of value.dates) {
    for (const range of value.slotsByDate[date] ?? []) {
      timeSlots.push({ start: range.start, end: range.end, dates: [date] });
    }
  }
  return {
    type: "date",
    title: value.title,
    ...(value.description ? { description: value.description } : {}),
    dates: [...value.dates],
    ...(timeSlots.length > 0 ? { timeSlots } : {}),
  };
}
